export const SELECT_ALL_ITEMS = 'SELECT_ALL_ITEMS';
export const UNSELECT_ALL_ITEMS = 'UNSELECT_ALL_ITEMS';
export const SELECT_ITEMS = 'SELECT_ITEMS';
export const UNSELECT_ITEMS = 'UNSELECT_ITEMS';
export const UNSELECT_ITEM = 'UNSELECT_ITEM';
